// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* .container {
  max-width: 1024px;
  margin-left: var(--mb-1-5);
  margin-right: var(--mb-1-5);
} */
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
ul li {
  list-style: none;
}
ul {
  margin: 0;
  padding: 0;
}
.errorText {
  color: rgb(186, 19, 19);
  font-weight: 600;
  font-size: 13px;
  margin: 0 !important;
  padding: 0 !important;
  margin-bottom: 10px;
}

form {
  margin: 10px 0;
  width: 100% !important;
}

img {
  width: 100%;
}

.errorImg {
  width: 40% !important;
}
.make-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-direction: column !important;
}
.lft {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  flex-direction: column !important;
}
.rht {
  display: flex !important;
  align-items: flex-end !important;
  justify-content: flex-end !important;
  flex-direction: column !important;
}

.css-wjh20t-MuiPagination-ul {
  align-items: flex-end;
  justify-content: flex-end;
}
.css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {
  background-color: rgb(0 43 255 / 20%) !important;
}
input {
  width: 100%;
}
.MuiFormControl-root.MuiTextField-root {
  margin-top: 14px;
  width: 100% !important;
}
input:-internal-autofill-selected {
  background-color: transparent !important;
}

.inputFile {
  position: relative;
  border: 1px solid rgb(164, 163, 163);
  width: 90px;
  height: 90px;
  cursor: pointer;
  border-radius: 10px;
}
.inputFile > input[type="file"] {
  display: none;
}
.inputFile label {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -1px;
  left: -1px;
  cursor: pointer;
  width: 91px;
  height: 90px;
}
.inputFile img {
  width: 90px;
  height: 90px;
  object-fit: contain;
  border-radius: 10px;
  padding: 1px;
  float: left;
}
.inputFile i {
  font-size: 26px;
  color: grey;
}
.emptyList {
  width: 100%;
  height: 100px;
  margin-top: 10%;
  color: gray;
}
.emptyList i {
  font-size: 70px;
}
.emptyList p {
  font-size: 20px;
  font-weight: 600;
  margin-top: 10px;
  text-transform: capitalize;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;AACA;;;;GAIG;AACH;EACE;aACW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,sCAAsC;EACtC,iCAAiC;AACnC;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/* .container {\n  max-width: 1024px;\n  margin-left: var(--mb-1-5);\n  margin-right: var(--mb-1-5);\n} */\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\nul li {\n  list-style: none;\n}\nul {\n  margin: 0;\n  padding: 0;\n}\n.errorText {\n  color: rgb(186, 19, 19);\n  font-weight: 600;\n  font-size: 13px;\n  margin: 0 !important;\n  padding: 0 !important;\n  margin-bottom: 10px;\n}\n\nform {\n  margin: 10px 0;\n  width: 100% !important;\n}\n\nimg {\n  width: 100%;\n}\n\n.errorImg {\n  width: 40% !important;\n}\n.make-center {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-direction: column !important;\n}\n.lft {\n  display: flex !important;\n  align-items: flex-start !important;\n  justify-content: flex-start !important;\n  flex-direction: column !important;\n}\n.rht {\n  display: flex !important;\n  align-items: flex-end !important;\n  justify-content: flex-end !important;\n  flex-direction: column !important;\n}\n\n.css-wjh20t-MuiPagination-ul {\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n.css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {\n  background-color: rgb(0 43 255 / 20%) !important;\n}\ninput {\n  width: 100%;\n}\n.MuiFormControl-root.MuiTextField-root {\n  margin-top: 14px;\n  width: 100% !important;\n}\ninput:-internal-autofill-selected {\n  background-color: transparent !important;\n}\n\n.inputFile {\n  position: relative;\n  border: 1px solid rgb(164, 163, 163);\n  width: 90px;\n  height: 90px;\n  cursor: pointer;\n  border-radius: 10px;\n}\n.inputFile > input[type=\"file\"] {\n  display: none;\n}\n.inputFile label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  cursor: pointer;\n  width: 91px;\n  height: 90px;\n}\n.inputFile img {\n  width: 90px;\n  height: 90px;\n  object-fit: contain;\n  border-radius: 10px;\n  padding: 1px;\n  float: left;\n}\n.inputFile i {\n  font-size: 26px;\n  color: grey;\n}\n.emptyList {\n  width: 100%;\n  height: 100px;\n  margin-top: 10%;\n  color: gray;\n}\n.emptyList i {\n  font-size: 70px;\n}\n.emptyList p {\n  font-size: 20px;\n  font-weight: 600;\n  margin-top: 10px;\n  text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
